import React, { Component, useState } from 'react';
import AddCardView from './AddCardView'
function AddCard(props) {
    return (
        <div>
            <AddCardView
                open = {props.open}
                form_id={props.form_id}
                isOverwriteDocument={props.isOverwriteDocument}
                html_content={props.html_add_card_content}
                onCloseAddCard = {props.onClose}/>
        </div>
    );
}

export default AddCard;